export default "__VITE_ASSET__BOHUDSJI__"